import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { api, apiError, fileUrl } from "@/lib/api";
import { SafeImage } from "@/components/ds/SafeImage";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.path);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-3">
      <input
        ref={inputRef}
        type="file"
        accept="image/png,image/jpeg,image/webp,image/gif"
        className="hidden"
        onChange={pick}
        data-testid={`${testid}-input`}
      />
      {value ? (
        <div className="relative">
          <SafeImage
            src={fileUrl(value)}
            alt="Foto"
            wrapperClassName="h-20 w-20 rounded-lg border border-white/10"
            fallbackLabel="sem preview"
            data-testid={`${testid}-preview`}
          />
          <button
            type="button"
            onClick={() => onChange(null)}
            data-testid={`${testid}-remove`}
            className="absolute -right-2 -top-2 rounded-full border border-white/10 bg-secondary p-1 text-muted-foreground transition-colors hover:text-destructive"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          data-testid={`${testid}-btn`}
          className="flex h-20 w-20 flex-col items-center justify-center gap-1 rounded-lg border border-dashed border-white/15 bg-secondary/40 text-muted-foreground transition-colors hover:border-primary/60 hover:text-brand"
        >
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <ImagePlus className="h-5 w-5" />}
          <span className="text-[10px]">Foto</span>
        </button>
      )}
      <p className="text-xs text-muted-foreground">PNG, JPG ou WEBP · até 5 MB</p>
    </div>
  );
}
